import React, { Component } from "react";
import { dataNuestras_voces } from "../data/dataNuestras_voces";

export default class Nuestras_voces extends Component {
  render() {
    // Agrupa la data por grupo
    const groupedData = dataNuestras_voces.reduce((acc, item) => {
      if (!acc[item.grupo]) {
        acc[item.grupo] = [];
      }
      acc[item.grupo].push(item);
      return acc;
    }, {});

    // Orden descendente
    const sortedGroups = Object.keys(groupedData).sort((a, b) => b - a);

    return (
      <>
        <h1 className="text-center mb-5 mt-4">VIDEOS</h1>

        <style>
          {`
            .Galeria__responsive {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 30px;
              margin-bottom: 70px;
            }

            .Galeria__responsive-item {
              width: 100%;
            }

            .video-card {
              background: #fff;
              border-radius: 20px;
              overflow: hidden;
              box-shadow: 0 8px 25px rgba(0,0,0,.12);
              transition: .3s ease;
            }

            .video-card:hover {
              transform: translateY(-5px);
              box-shadow: 0 12px 30px rgba(0,0,0,.18);
            }

            .video-title {
              font-size: 1.1rem;
              font-weight: 700;
              padding: 18px 20px 10px;
              text-align: center;
              color: #222;
            }

            .video-container {
              position: relative;
              width: 100%;
              padding-bottom: 56.25%;
              height: 0;
              overflow: hidden;
            }

            .video-container iframe {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: none;
            }

            @media (max-width: 768px) {
              .Galeria__responsive {
                grid-template-columns: 1fr;
                gap: 20px;
              }

              .video-title {
                font-size: 1rem;
              }
            }
          `}
        </style>

        {/* Renderizado */}
        {sortedGroups.map((grupo) => (
          <div key={grupo} className="Galeria__responsive">
            {groupedData[grupo].map((video) => (
              <div
                key={video.id}
                className="Galeria__responsive-item"
              >
                <div className="video-card">

                  {/* TITULO */}
                  <div className="video-title">
                    {video.alt}
                  </div>

                  {/* VIDEO */}
                  <div className="video-container">
                    <iframe
                      src={video.iframeURL}
                      title={video.alt}
                      allow="autoplay"
                      allowFullScreen
                    ></iframe>
                  </div>

                </div>
              </div>
            ))}
          </div>
        ))}
      </>
    );
  }
}